export default "__VITE_ASSET__Cir1xXxw__"